<script setup lang="ts"></script>

<template>
  <div class="col-md-6 mb-4">
    <h3>Our Information</h3>
    <ul class="list-unstyled">
      <li><strong>Phone:</strong> 8 705 525 35 84</li>
      <li><strong>Email:</strong> VueReact@gmail.com</li>
      <li><strong>Address:</strong> Kazakhstan, Shymkent</li>
    </ul>
    <div
      class="mt-4"
      role="region"
      aria-labelledby="follow-us"
    >
      <h5 id="follow-us">Follow Us</h5>
      <div class="d-flex flex-wrap gap-2">
        <a
          href="https://www.facebook.com/abdu248616"
          class="btn btn-outline-primary btn-sm me-2"
        >
          <i class="bi bi-facebook"></i> Facebook
        </a>
        <a
          href="https://wa.me/87782523794"
          class="btn btn-outline-success btn-sm me-2"
        >
          <i class="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a
          href="#"
          class="btn btn-outline-info btn-sm me-2 text-decoration-line-through"
        >
          <i class="bi bi-twitter"></i> Twitter
        </a>
        <a
          href="#"
          class="btn btn-outline-danger btn-sm text-decoration-line-through"
        >
          <i class="bi bi-instagram"></i> Instagram
        </a>
      </div>
    </div>
  </div>
</template>
